import {Component, Input} from '@angular/core'
import {PromotionalBannerSection} from '../../../../core/content/types/promotional-banner-section.types'
import {BreakpointService} from '../../../../craft/utils/breakpoint.service'

@Component({
  selector: 'bgo-promotional-banner-section',
  templateUrl: './promotional-banner-section.component.html',
  styles: [':host { display: block }'],
})
export class PromotionalBannerSectionComponent {
  @Input() section!: PromotionalBannerSection
  @Input() fullContent = false

  constructor(readonly breakpointService: BreakpointService) {}
}
